import { motion } from "framer-motion";
import { Search, Pencil, Wrench, Sparkles, Repeat } from "lucide-react";
import { HOW_WE_WORK_STEPS } from "../../lib/solutions";

const ICONS = { Search, Pencil, Wrench, Sparkles, Repeat };

export default function HowWeWork() {
  return (
    <section
      data-testid="how-we-work-section"
      className="relative bg-white border-y-2 border-[#1A1A1A] overflow-hidden"
    >
      <div className="absolute inset-0 bg-dots opacity-40 pointer-events-none" />
      <div className="relative mx-auto max-w-7xl px-5 md:px-10 lg:px-12 py-20 md:py-28">
        <div className="max-w-3xl">
          <p className="font-mono text-xs tracking-[0.25em] uppercase text-[#0055FF]">
            How we work
          </p>
          <h2 className="mt-4 font-display font-black text-4xl sm:text-5xl lg:text-6xl leading-[1.02] tracking-tighter">
            From vision to action.
          </h2>
          <p className="mt-5 text-base md:text-lg text-[#4A4A4A] font-medium leading-relaxed">
            A clear, repeatable five-step process we run alongside every school,
            library and council we partner with.
          </p>
        </div>

        <div className="mt-14 relative">
          {/* connecting line (desktop) */}
          <div
            aria-hidden
            className="hidden lg:block absolute left-0 right-0 top-10 h-[3px] bg-[repeating-linear-gradient(90deg,#1A1A1A_0_12px,transparent_12px_22px)]"
          />
          <ol className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-5 gap-6 relative">
            {HOW_WE_WORK_STEPS.map((step, i) => {
              const Icon = ICONS[step.icon] || Sparkles;
              return (
                <motion.li
                  key={step.n}
                  initial={{ opacity: 0, y: 30 }}
                  whileInView={{ opacity: 1, y: 0 }}
                  viewport={{ once: true, amount: 0.3 }}
                  transition={{ duration: 0.6, delay: i * 0.08, ease: [0.22, 1, 0.36, 1] }}
                  data-testid={`how-we-work-step-${step.n}`}
                  className="relative"
                >
                  <div
                    className="h-20 w-20 mx-auto rounded-2xl border-2 border-[#1A1A1A] flex items-center justify-center nb-shadow relative z-10"
                    style={{ backgroundColor: step.color }}
                  >
                    <Icon size={28} strokeWidth={2.5} />
                  </div>
                  <div className="mt-5 rounded-2xl border-2 border-[#1A1A1A] bg-white p-5 nb-shadow-sm text-center min-h-[180px]">
                    <p className="font-mono text-[11px] uppercase tracking-widest text-[#4A4A4A]">
                      Step {step.n}
                    </p>
                    <h3 className="mt-1 font-display font-black text-xl tracking-tighter">
                      {step.title}
                    </h3>
                    <p className="mt-2 text-sm text-[#4A4A4A] font-semibold leading-relaxed">
                      {step.body}
                    </p>
                  </div>
                </motion.li>
              );
            })}
          </ol>
        </div>
      </div>
    </section>
  );
}
